import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { NavController } from '@ionic/angular';
import { Checklist } from 'src/app/models/checklist.model';
import { CommonService } from 'src/app/services/common.service';
import { constants } from 'src/app/utils/constants';
// import * as riskQuestionaryJson from 'src/app/utils/riskQuestionary.json';
import * as riskQuestionaryJson from 'src/app/utils/riskQuestionaryCricket.json';

@Component({
  selector: 'app-risk',
  templateUrl: './risk.component.html',
  styleUrls: ['./risk.component.scss'],
  standalone: false
})
export class RiskComponent  implements OnInit {

  public accessibleMode: string = '';
  public riskInformations: any[] = [];
  public isValid: boolean = false;
  public riskQuest: any[] = [];
  public itemId: string = '';
  public riskQuestionaryForm: FormGroup;
  public currentImage: any;
  public imageList: any[] = [];
  public imageList2: any[] = [];
  private totalImageSizeInBytes: number = 0;


  constructor(
    private formBuilder: FormBuilder,
    private navController: NavController,
    private router: Router,
    private commonService: CommonService,
  ) {
    this.riskQuestionaryForm = this.formBuilder.group({
      riskQuestionary: this.formBuilder.array([])
    });
  }

  ngOnInit() {
    this.initializeApp();
    this.commonService.pushCurrentTabPosition(4);
  }

  async initializeApp() {
    if (this.router?.getCurrentNavigation()?.extras.state?.[constants.QUERY_PARAMS].itemId) {
      this.accessibleMode = this.router?.getCurrentNavigation()?.extras.state?.[constants.QUERY_PARAMS].accessibleMode;
      this.itemId = this.router?.getCurrentNavigation()?.extras.state?.[constants.QUERY_PARAMS].itemId;
      const checkItem: Checklist = await this.commonService.getItem(this.itemId);

      if ((this.accessibleMode === constants.VIEW || this.accessibleMode === constants.EDIT)
      && (JSON.stringify(checkItem.risk) !== '{}' && JSON.stringify(checkItem.risk) !== '[]')
      && !this.commonService.checkIfArrayEmpty(JSON.parse(JSON.stringify(checkItem.risk)))) { 
        this.commonService.setCurrentMode(this.accessibleMode, checkItem);
        this.riskQuest = checkItem.risk;
        const riskQuestionaryArray = Object.values(riskQuestionaryJson);
        this.riskQuestionary.clear(); 
        for (let i = 0; i < riskQuestionaryArray.length; i++) {
          const question = riskQuestionaryArray[i];
          if (question.questionName) {
            const riskQuestElement = this.riskQuest[i];
            if (riskQuestElement) {
              const riskkey = Object.keys(riskQuestElement)[0];
              const riskValue = riskQuestElement[riskkey];
              const supportingInfoValue = riskQuestElement[Object.keys(riskQuestElement)[1]];
              const questionImageValue = riskQuestElement[Object.keys(riskQuestElement)[2]];
              const questionImage2Value = riskQuestElement[Object.keys(riskQuestElement)[3]];
              const supportingInfo = supportingInfoValue ? supportingInfoValue : constants.EMPTY;
              if (question.questionResultFormt === riskkey) {
                const riskQuestionGroup = this.formBuilder.group({
                  questionType: [question.questionType],
                  question: [question.question],
                  questionName: [question.questionName, [Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]],
                  questionResponse: [riskValue ? riskValue : constants.EMPTY, Validators.required],
                  questionSupportInfo: [{ value: supportingInfo, disabled: (this.accessibleMode === constants.VIEW) },
                    Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS_RETURN)],
                  questionResultFormt: [question.questionResultFormt],
                  questionImage: [questionImageValue],
                  questionImage2: [questionImage2Value]
                });
                this.riskQuestionary.push(riskQuestionGroup);
                this.imageList[i] = riskQuestionGroup.get('questionImage')?.value;
                this.imageList2[i] = riskQuestionGroup.get('questionImage2')?.value;
                this.totalImageSizeInBytes += this.calculateImageSize(this.imageList[i]);
                this.totalImageSizeInBytes += this.calculateImageSize(this.imageList2[i]);
              }
            }
            // console.log(riskQuestElement);
          }
        }
        // console.log(this.riskQuestionary.controls);

      } else {
        this.setQuestionary();
      }
    }
    else {
      this.navController.navigateForward(constants.PAGE.CHECKLIST);
    }
  }

  get riskQuestionary(): FormArray {
    return this.riskQuestionaryForm.get(constants.RISK_QUESTIONARY) as FormArray;
  }

  public setQuestionary() {
    for (let i in riskQuestionaryJson) {
      if (riskQuestionaryJson[i].questionName) {
        const riskQuestionGroup = this.formBuilder.group({
          questionType: [riskQuestionaryJson[i].questionType],
          question: [riskQuestionaryJson[i].question],
          questionName: [riskQuestionaryJson[i].questionName],
          questionResponse: [riskQuestionaryJson[i].questionResponse, Validators.required],
          questionSupportInfo: [riskQuestionaryJson[i].questionSupportInfo, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS_RETURN)],
          questionResultFormt: [riskQuestionaryJson[i].questionResultFormt],
          questionImage: [riskQuestionaryJson[i].questionImage],
          questionImage2: [riskQuestionaryJson[i].questionImage2]
        });
        this.riskQuestionary.push(riskQuestionGroup);
      }
    }
  }

  public async nextPage() {
    console.log('Total images size in KiloBytes: ', (this.totalImageSizeInBytes/1024));
    if (!this.isValidData()) {
      const firstInvalidControl = this.findFirstInvalidControl();
      if (firstInvalidControl) {
        console.log('element is' + firstInvalidControl);
        const element = document.getElementById(firstInvalidControl);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus(); // Delay to ensure scrolling is complete
        }
      }
      if ((this.totalImageSizeInBytes / 1024) > 5120) {
        alert('Total images size should not exceed 5MB');
      }
      return; // Prevent further processing
    }
        
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: this.accessibleMode,
          itemId: this.itemId
        }
      }
    };
    this.commonService.pushCurrentTabPosition(5);
    var riskQuest = this.riskQuestionary;
    this.riskQuest = this.riskQuestionaryForm.get(constants.RISK_QUESTIONARY)?.value;
    for (let index = 0; index < riskQuest.length; index++) {
      var riskInfo: any = {
        [this.riskQuest[index].questionResultFormt]: this.riskQuest[index].questionResponse,
        [this.riskQuest[index].questionResultFormt + '.supportInfo']: this.riskQuest[index].questionSupportInfo,
        [this.riskQuest[index].questionResultFormt + '.questionImage']: this.riskQuest[index].questionImage,
        [this.riskQuest[index].questionResultFormt + '.questionImage2']: this.riskQuest[index].questionImage2
      }
     this.riskInformations.push(riskInfo);
    }
    // console.log(this.riskInformations);
    if (this.accessibleMode === constants.VIEW) {
     await this.navController.navigateForward(constants.PAGE.DECLARATION, navigationExtras);
    }
    else if (this.accessibleMode === constants.NEW || this.accessibleMode === constants.EDIT) {
      var returnItemId: string = await this.commonService.insertChecklistItem(this.itemId, constants.RISK, this.riskInformations);
      if (this.itemId === returnItemId) {
       await this.navController.navigateForward(constants.PAGE.DECLARATION, navigationExtras);
      }
    } else {
      await this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: true });
    }    
  }

  public backToPage() {
    this.commonService.pushCurrentTabPosition(3);
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: this.accessibleMode,
          itemId: this.itemId
        }
      }
    };
    this.navController.navigateBack(constants.PAGE.PARTIES, navigationExtras);
  }

  public isValidData(): boolean {
    var riskQuest: any[] = this.riskQuestionaryForm.get(constants.RISK_QUESTIONARY)?.value;
    const allQuestionMarkedCount = riskQuest.filter(x => x.questionResponse === '').length;
    const noSelectedWithSupportCount = riskQuest.filter(x => x.questionResponse === 'No' && x.questionSupportInfo === '').length;
    if (this.riskQuestionaryForm.status == 'INVALID') {
      return false;
    }
    if (noSelectedWithSupportCount > 0) {
      this.riskQuestionaryForm.markAllAsTouched();
      return false;
    } else if (allQuestionMarkedCount === 0 && noSelectedWithSupportCount === 0) {
      return true;
    } else {
      this.riskQuestionaryForm.markAllAsTouched();
      return false;
    }
  }

  public camelize(str: string) {
    //This method may be use in future to convert camleLetter.
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  private findFirstInvalidControl(): string | null {
    for (let i = 0; i < this.riskQuestionary.controls.length; i++) {
      const control = this.riskQuestionary.at(i);
      if (control.invalid) {
        console.log('Invalid Control');
        // Check for specific controls
        if (control.get('questionResponse')?.invalid) {
          console.log('Invalid Control' + `questionResponse-${i}`);
          return `questionResponse_${i}`; // Return the ID of the first invalid questionResponse
        }
        if (control.get('questionSupportInfo')?.invalid) {
          console.log('Invalid Control' + `questionSupportInfo-${i}`);
          return `questionSupportInfo_${i}`; // Return the ID of the first invalid questionSupportInfo
        }
      }
    }
    return null; // No invalid controls found
  }

  // public async takePicture(index: number) {
  //   try {
  //     if (Capacitor.getPlatform() != 'web') {
  //       await Camera.requestPermissions();
  //     }
  //     const capturedImage = await Camera.getPhoto({
  //       quality: 60,
  //       source: CameraSource.Prompt,
  //       width: 120,
  //       resultType: CameraResultType.DataUrl
  //     });
  //     console.log('image', capturedImage);
  //     this.currentImage = capturedImage.dataUrl;
  //     this.imageList[index] = this.currentImage;
  //     // this.riskQuestionary[index].questionImage = this.currentImage;
  //     this.riskQuestionary.at(index).get('questionImage')?.setValue(this.currentImage);
  //   } catch(e) {
  //     console.log(e);
  //   }
  // }


  public async takePictureCompressed(index: number) {
    try {
      if (Capacitor.getPlatform() != 'web') {
        await Camera.requestPermissions();
      }
      const capturedImage = await Camera.getPhoto({
        source: CameraSource.Prompt,
        resultType: CameraResultType.DataUrl,
      });
      
      if (capturedImage.dataUrl) {
        const img = new Image();
        img.src = capturedImage?.dataUrl;

        const validFormats = ['jpeg', 'png', 'gif', 'tiff', 'bmp'];

        if (validFormats.includes(capturedImage.format)) {
          img.onload = async () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
  
            const desiredWidth = 400; // to lower the size of base64 image adjust this property
            const scalingFactor = desiredWidth / img.width;
            const desiredHeight = scalingFactor * img.height;
            const quality = 0.5; // quality has little to no effect on the size
   
  
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
  
            ctx?.drawImage(img, 0, 0, desiredWidth, desiredHeight);
  
            const resizedImageDataUrl = canvas.toDataURL(capturedImage.format, quality);

            this.totalImageSizeInBytes += this.calculateImageSize(resizedImageDataUrl);

            if ((this.totalImageSizeInBytes / 1024) > 4096) {
              alert('Total images size exceeded 4MB');
              return;
            }
            
            this.currentImage = resizedImageDataUrl
            this.imageList[index] = this.currentImage;
            this.riskQuestionary.at(index).get('questionImage')?.setValue(this.currentImage);
          };
        } else {
          alert('Please select JPEG/JPG, PNG, GIF, TIFF or BMP  format only');
        }

      } else {
        console.error('No data url returned from the camera');
      }
    } catch(e) {
      console.error(e);
    }
  }

  public async takePictureCompressed2(index: number) {
    try {
      if (Capacitor.getPlatform() != 'web') {
        await Camera.requestPermissions();
      }
      const capturedImage = await Camera.getPhoto({
        source: CameraSource.Prompt,
        resultType: CameraResultType.DataUrl,
      });
      
      if (capturedImage.dataUrl) {
        const img = new Image();
        img.src = capturedImage?.dataUrl;

        const validFormats = ['jpeg', 'png', 'gif', 'tiff', 'bmp'];

        if (validFormats.includes(capturedImage.format)) {
          img.onload = async () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
  
            const desiredWidth = 400; // to lower the size of base64 image adjust this property
            const scalingFactor = desiredWidth / img.width;
            const desiredHeight = scalingFactor * img.height;
            const quality = 0.5; // quality has little to no effect on the size
   
  
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
  
            ctx?.drawImage(img, 0, 0, desiredWidth, desiredHeight);
  
            const resizedImageDataUrl = canvas.toDataURL(capturedImage.format, quality);

            this.totalImageSizeInBytes += this.calculateImageSize(resizedImageDataUrl);

            if ((this.totalImageSizeInBytes / 1024) > 4096) {
              alert('Total images size exceeded 4MB');
              return;
            }
            
            this.currentImage = resizedImageDataUrl
            this.imageList2[index] = this.currentImage;
            this.riskQuestionary.at(index).get('questionImage2')?.setValue(this.currentImage);
          };
        } else {
          alert('Please select JPEG/JPG, PNG, GIF, TIFF or BMP  format only');
        }

      } else {
        console.error('No data url returned from the camera');
      }
    } catch(e) {
      console.error(e);
    }
  }

  public removePicture(index: number) {
    this.totalImageSizeInBytes -= this.calculateImageSize(this.imageList[index]);
    this.currentImage = null;
    this.imageList[index] = "";
    this.riskQuestionary.at(index).get('questionImage')?.setValue(null);
  }

  public removePicture2(index: number) {
    this.totalImageSizeInBytes -= this.calculateImageSize(this.imageList2[index]);
    this.currentImage = null;
    this.imageList2[index] = "";
    this.riskQuestionary.at(index).get('questionImage2')?.setValue(null);
  }

  public calculateImageSize(image: any): number {
    if (image) {
      const base64Length = image.length;
      const padding = (image.endsWith('==') ? 2 : (image.endsWith('=') ? 1 : 0));
      const sizeInBytes = (base64Length * 3) / 4 - padding;
      return sizeInBytes;
    }
    return 0;
  }

}
